import React from 'react';
import './Tickets.css';

// Import required components and constants
import { Heading, Ticket } from '../../../components';
import { tickets } from '../../../constants';



const Tickets = () => {
  return (
    <section className='tickets'>

      {/* Heading for the Pricing section */}
      <Heading title={'Contact your local representative'} subTitle={'Registration'} />

      {/* Ticket container */}
      <div className='box-container'> 
        {/* Loop through each ticket and render the Ticket component */}
        {tickets.map((ticket, index) => (
          <Ticket key={index} {...ticket} />
        ))
        }
      </div>

    </section>
  )
}

export default Tickets;